import { Template } from "@suse-o11y/template";
import { z } from "zod";

import { dashboardVariableLabelName } from "./_dashboard-variable-label-name";

export const dashboardMetricPromQLVariableSchema = z.object({
	labelName: dashboardVariableLabelName,
	expr: z
		.string()
		.trim()
		.min(1, "Expression cannot be empty")
		.catch("")
		.transform((trimmed) => Template<null>(trimmed)),
});

export type DashboardMetricPromQLVariable = z.infer<typeof dashboardMetricPromQLVariableSchema>;
